export { default } from "./src/modal";
